import { Outlet } from 'react-router-dom';

import useEnv from '@zenbusiness/application-commons-env';
import PageError from '@zenbusiness/zui/PageError';

/**
 * Router outlet which conditionally renders based on the environment.
 * This gate will prevent access in production environments.
 *
 * @param {object} props
 * @param {*} props.children
 * @component
 */
export default function DevelopmentGate({ children }) {
  const { DEPLOY_ENV } = useEnv('root-first'); // use parent values

  if (DEPLOY_ENV === 'production') {
    return <PageError />;
  }

  return children || <Outlet />;
}
